/* MacShack ASUS ProArt page: ΔE patch test, CIE 1931 gamut, pixel-density loupes, craft tabs. */
(function () {
  'use strict';

  /* ---------- colour maths (sRGB, D65) ---------- */
  function lin2s(c) { c = Math.max(0, Math.min(1, c)); return c <= 0.0031308 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055; }
  function s2lin(c) { return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
  function hex2rgb(h) { return [1, 3, 5].map(function (i) { return parseInt(h.substr(i, 2), 16) / 255; }); }
  function rgb2lab(rgb) {
    var r = s2lin(rgb[0]), g = s2lin(rgb[1]), b = s2lin(rgb[2]);
    var X = (r * .4124 + g * .3576 + b * .1805) / .95047, Y = r * .2126 + g * .7152 + b * .0722, Z = (r * .0193 + g * .1192 + b * .9505) / 1.08883;
    function f(t) { return t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; }
    return [116 * f(Y) - 16, 500 * (f(X) - f(Y)), 200 * (f(Y) - f(Z))];
  }
  function lab2css(L, a, bb) {
    var fy = (L + 16) / 116, fx = fy + a / 500, fz = fy - bb / 200;
    function fi(t) { return t * t * t > 0.008856 ? t * t * t : (t - 16 / 116) / 7.787; }
    var X = fi(fx) * .95047, Y = fi(fy), Z = fi(fz) * 1.08883;
    var r = X * 3.2406 + Y * -1.5372 + Z * -.4986, g = X * -.9689 + Y * 1.8758 + Z * .0415, b = X * .0557 + Y * -.2040 + Z * 1.0570;
    return 'rgb(' + [r, g, b].map(function (c) { return Math.round(lin2s(c) * 255); }).join(',') + ')';
  }

  /* ---------- ΔE patch test (ColorChecker patches) ---------- */
  function initDeltaE(root) {
    var range = root.querySelector('[data-de-range]'), pick = root.querySelector('[data-de-pick]');
    if (!range || !pick) return;
    var ref = root.querySelector('[data-de-ref]'), test = root.querySelector('[data-de-test]'), val = root.querySelector('[data-de-val]'), verdict = root.querySelector('[data-de-verdict]');
    var patches = [['Dark skin', '#735244'], ['Light skin', '#c29682'], ['Blue sky', '#627a9d'], ['Foliage', '#576c43'], ['Blue flower', '#8580b1'], ['Bluish green', '#67bdaa'], ['Orange', '#d67e2c'], ['Neutral grey', '#a0a0a0']];
    var cur = 2;
    function draw() {
      var lab = rgb2lab(hex2rgb(patches[cur][1])), d = +range.value;
      ref.style.background = patches[cur][1];
      test.style.background = lab2css(lab[0] + d * .2, lab[1] + d * .55, lab[2] + d * .81);
      val.textContent = 'ΔE ' + d.toFixed(1);
      verdict.textContent = d < 2 ? 'Looks identical' : d < 5 ? 'Visible side by side' : 'Obvious at a glance';
      verdict.classList.toggle('is-ok', d < 2);
    }
    patches.forEach(function (p, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.style.background = p[1]; b.setAttribute('aria-label', p[0]); b.setAttribute('aria-pressed', i === cur ? 'true' : 'false');
      b.addEventListener('click', function () {
        cur = i;
        Array.prototype.forEach.call(pick.children, function (c, j) { c.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        draw();
      });
      pick.appendChild(b);
    });
    range.addEventListener('input', draw);
    draw();
  }

  /* ---------- CIE 1931 chromaticity diagram ---------- */
  var LOCUS = [[.1741,.005],[.1733,.0048],[.1714,.0051],[.1689,.0069],[.1644,.0109],[.1566,.0177],[.144,.0297],[.1355,.0399],[.1241,.0578],[.1096,.0868],[.0913,.1327],[.0687,.2007],[.0454,.295],[.0235,.4127],[.0082,.5384],[.0039,.6548],[.0139,.7502],[.0389,.812],[.0743,.8338],[.1142,.8262],[.1547,.8059],[.1929,.7816],[.2296,.7543],[.2658,.7243],[.3016,.6923],[.3373,.6589],[.3731,.6245],[.4087,.5896],[.4441,.5547],[.4788,.5202],[.5125,.4866],[.5448,.4544],[.5752,.4242],[.6029,.3965],[.627,.3725],[.6658,.334],[.6915,.3083],[.7079,.292],[.719,.2809],[.726,.274],[.73,.27],[.7334,.2666],[.7347,.2653]];
  var SPACES = { srgb: [[.64,.33],[.30,.60],[.15,.06]], p3: [[.68,.32],[.265,.69],[.15,.06]], adobe: [[.64,.33],[.21,.71],[.15,.06]] };
  function initGamut(root) {
    var gc = root.querySelector('[data-gamut]'); if (!gc || !gc.getContext) return;
    var gx = gc.getContext('2d'), W = gc.width, pad = 70, base = null, cs = 'p3';
    var note = root.querySelector('[data-gam-note]'), btns = root.querySelectorAll('.seg button');
    function X(x) { return pad + x / .8 * (W - pad * 1.4); }
    function Y(y) { return W - pad - y / .9 * (W - pad * 1.6); }
    function inside(px, py, poly) { var c = false; for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) { var a = poly[i], b = poly[j]; if ((a[1] > py) !== (b[1] > py) && px < (b[0] - a[0]) * (py - a[1]) / (b[1] - a[1]) + a[0]) c = !c; } return c; }
    function drawBase() {
      var img = gx.createImageData(W, W), poly = LOCUS.map(function (p) { return [X(p[0]), Y(p[1])]; });
      for (var py = 0; py < W; py++) for (var px = 0; px < W; px++) {
        if (!inside(px, py, poly)) continue;
        var x = (px - pad) / (W - pad * 1.4) * .8, y = (W - pad - py) / (W - pad * 1.6) * .9; if (y <= 0.001) continue;
        var Xv = x / y, Zv = (1 - x - y) / y;
        var r = Xv * 3.2406 - 1.5372 - .4986 * Zv, g = -.9689 * Xv + 1.8758 + .0415 * Zv, b = .0557 * Xv - .204 + 1.057 * Zv;
        var m = Math.max(r, g, b); r = Math.max(0, r / m); g = Math.max(0, g / m); b = Math.max(0, b / m);
        var k = (py * W + px) * 4; img.data[k] = lin2s(r) * 255; img.data[k + 1] = lin2s(g) * 255; img.data[k + 2] = lin2s(b) * 255; img.data[k + 3] = 150;
      }
      gx.putImageData(img, 0, 0);
      gx.strokeStyle = 'rgba(243,242,246,.35)'; gx.lineWidth = 2; gx.beginPath();
      poly.forEach(function (p, i) { if (i) gx.lineTo(p[0], p[1]); else gx.moveTo(p[0], p[1]); }); gx.closePath(); gx.stroke();
      gx.fillStyle = '#8b8a96'; gx.font = '22px "IBM Plex Mono", ui-monospace, monospace';
      [.1, .3, .5, .7].forEach(function (t) { gx.fillText(t.toFixed(1), X(t) - 16, W - pad + 34); });
      [.2, .4, .6, .8].forEach(function (t) { gx.fillText(t.toFixed(1), pad - 54, Y(t) + 7); });
      gx.fillText('x', W - pad * .6, W - pad + 34); gx.fillText('y', pad - 54, pad * .6);
      base = gx.getImageData(0, 0, W, W);
    }
    function tri(p, col, w) { gx.strokeStyle = col; gx.lineWidth = w; gx.beginPath(); p.forEach(function (q, i) { if (i) gx.lineTo(X(q[0]), Y(q[1])); else gx.moveTo(X(q[0]), Y(q[1])); }); gx.closePath(); gx.stroke(); }
    function draw() {
      if (!base) drawBase(); else gx.putImageData(base, 0, 0);
      if (cs !== 'srgb') { gx.setLineDash([10, 10]); tri(SPACES.srgb, 'rgba(243,242,246,.55)', 2); gx.setLineDash([]); }
      tri(SPACES[cs], '#ffffff', 5);
    }
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () {
        cs = b.getAttribute('data-g');
        Array.prototype.forEach.call(btns, function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        if (note) note.textContent = b.getAttribute('data-note');
        draw();
      });
    });
    /* Draw when the chart comes near the screen: the pixel fill is the heaviest work on the page. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); draw(); } }, { rootMargin: '400px 0px' });
      io.observe(gc);
    } else { draw(); }
  }

  /* ---------- pixel loupes: same physical size, pixel count scaled by PPI ---------- */
  function initLoupes(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-loupe]'), function (c) {
      if (!c.getContext) return;
      var ppi = +c.getAttribute('data-loupe'), x = c.getContext('2d'), n = Math.round(ppi / 218 * 22);
      var o = document.createElement('canvas'); o.width = n; o.height = n; var ox = o.getContext('2d');
      ox.fillStyle = '#fff'; ox.fillRect(0, 0, n, n); ox.fillStyle = '#18181b';
      ox.font = '600 ' + (n * .42) + 'px -apple-system, "Helvetica Neue", Arial, sans-serif'; ox.textBaseline = 'middle'; ox.fillText('Ag', n * .1, n * .5);
      x.imageSmoothingEnabled = false; x.drawImage(o, 0, 0, c.width, c.height);
      x.strokeStyle = 'rgba(0,0,0,.12)'; x.lineWidth = 1; var s = c.width / n;
      for (var i = 1; i < n; i++) { x.beginPath(); x.moveTo(i * s, 0); x.lineTo(i * s, c.height); x.stroke(); x.beginPath(); x.moveTo(0, i * s); x.lineTo(c.width, i * s); x.stroke(); }
    });
  }

  /* ---------- craft tabs (all panels are server-rendered; tabs show one) ---------- */
  function initTabs(root) {
    var list = root.querySelector('[data-tabs]'); if (!list) return;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    function show(i, focus) {
      tabs.forEach(function (t, j) {
        var on = j === i, panel = document.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        if (panel) panel.hidden = !on;
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show((i + 1) % tabs.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show((i + tabs.length - 1) % tabs.length, true); }
      });
    });
  }

  function init(root) {
    if (root.__mas) return; root.__mas = true;
    initDeltaE(root); initGamut(root); initLoupes(root); initTabs(root);
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-mas]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
